module.exports = __webpack_public_path__ + "img/star-blue-icon.91e1763b.svg";